export const S3_BASE_URL = 'https://s3.ap-south-1.amazonaws.com/payroll-inn-s3/po-stars/';